import { apiAuth, apiResponseType } from ".";

export const getCircuitRoutesData = (params: {
  start_date: string;
  end_date: string;
  title?: string;
}): apiResponseType => {
  const queryParams = new URLSearchParams();
  queryParams.set("start_date", params.start_date);
  queryParams.set("end_date", params.end_date);
  if (params.title) {
    queryParams.set("title", params.title);
  }
  return apiAuth.get(
    `circuit-routes/select?${queryParams.toString()}`
  ) as apiResponseType;
};

export const listCircuitRoutes = (params?: {
  start_date?: string;
  end_date?: string;
  title?: string;
  page?: number;
}): apiResponseType => {
  const queryParams = new URLSearchParams();
  params?.start_date && queryParams.set("start_date", params.start_date);
  params?.end_date && queryParams.set("end_date", params.end_date);
  params?.title && queryParams.set("title", params.title);
  params?.page && queryParams.set("page", params.page.toString());
  return apiAuth.get(`circuit-routes?${queryParams.toString()}`);
};

export const searchCircuitRoutes = ({
  name,
  start_date,
  end_date,
}: {
  name?: string;
  start_date?: string;
  end_date?: string;
}): apiResponseType => {
  const queryParams = new URLSearchParams();
  name && queryParams.set("title", name);
  start_date && queryParams.set("start_date", start_date);
  end_date && queryParams.set("end_date", end_date);
  return apiAuth.get(`circuit-routes/search?${queryParams.toString()}`);
};

export const registerCircuitRoute = (data: {
  title: string;
  starts: {
    day: number;
    month: number;
    year: number;
  };
}): apiResponseType => {
  return apiAuth.post("circuit-routes/store", data);
};

export const deleteCircuitRoute = (plan_id: number): apiResponseType => {
  return apiAuth.delete(`circuit-routes/remove/${plan_id}`);
};

export const updateCircuitRoute = (data: {
  title: string;
  planId: string;
}): apiResponseType => {
  return apiAuth.put(`circuit-routes/update/${data?.planId}`, data);
};

export const getCircuitRoute = (id: number): apiResponseType => {
  return apiAuth.get(`circuit-routes/show/${id}`);
};

export const updateToggleActiveRoute = (id: number) =>
  apiAuth.put(`circuit-routes/${id}/update-toggle`) as apiResponseType;
